EMMY.entryAutocomplete = {
  init: function () {

    EMMY.entryAutocomplete.programTitle();
    EMMY.entryAutocomplete.episodeTitle();
    EMMY.entryAutocomplete.episodeTitleFromEpisodeBlock();
  },
  programTitle: function() {
      var optionsProgramTitle = {
        url: function (phrase) {
          if (phrase !== "") {
            return "/api/entry/" + EMMY.entrants.entryId + "/autocomplete" + "?program_title=" + phrase;
          }
        },
        getValue: "dataText",
        minCharNumber: 2,
        listLocation: 'entries',
        highlightPhrase: true,

        ajaxSettings: {
          dataType: "json",
          method: "POST",
        },
        list: {
          maxNumberOfElements: 10,
          match: {
            enabled: true
          },
          sort: {
            enabled: true
          },
        },
        requestDelay: 100,
        theme: "square"
      };
    $('.program_title').easyAutocomplete(optionsProgramTitle);
  },
  episodeTitle: function() {
      var optionsEpisodeName= {
        url: function(phrase) {
          if (phrase !== "") {
            return "/api/entry/"+EMMY.entrants.entryId+"/autocomplete"+"?episode_name=" + phrase;
          }
        },
        getValue: "dataText",
        minCharNumber: 2,
        listLocation: 'entries',
        highlightPhrase: true,

        ajaxSettings: {
          dataType: "json",
          method: "POST",
        },
        list: {
          maxNumberOfElements: 10,
          match: {
            enabled: true
          },
          sort: {
            enabled: true
          },
        },
        requestDelay: 100,
        theme: "square"
      };
      $('.episode_name:not(.episode_name_fromblock)').easyAutocomplete(optionsEpisodeName);
  },
  episodeTitleFromEpisodeBlock: function() {
    var optionsEpisodeName= {
      url: function(phrase) {
        if (phrase !== "") {
          return "/api/entry/"+EMMY.entrants.entryId+"/autocomplete"+"?episode_name_block=" + phrase;
        }
      },
      getValue: "dataText",
      minCharNumber: 2,
      listLocation: 'entries',
      highlightPhrase: true,

      ajaxSettings: {
        dataType: "json",
        method: "POST",
      },
      list: {
        maxNumberOfElements: 10,
        match: {
          enabled: true
        },
        sort: {
          enabled: true
        },
      },
      requestDelay: 100,
      theme: "square"
    };
    $('.episode_name_fromblock').easyAutocomplete(optionsEpisodeName);
  },
};